import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetAll } from '../../service/BlogService';

export default function GridBlog() {
  const {
    setIsLoading,
    setAppError,
    setAppErrorMessage,
    setAppErrorTitle,
    setAppErrorMode,
  } = useGlobalContext();

  const [blogs, setBlogs] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(6);
  const [totalPages, setTotalPages] = useState(1);

  const fetchBlogList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await GetAll(currentPage, limit, keyword);
      setBlogs(response.blogs || []);
      setTotalPages(response.totalPages || 1); // backend should return totalPages
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogList(page);
  }, [page]);

  return (
    <>
      <div className='container'>

        {/* start of page */}
        <div className='page'>

          <div className='page-heading'>
            <h1>Blogs</h1>
            <span>
              <Link to="/"> Dashboard </Link> / All Blogs
            </span>
          </div>

          {/* start of page content */}
          <div className='page-content'>

            {/* lastest blog */}
            <div className='row'>
              <div className='col-lg-12 col-md-4 col-sm-12 col-12'>
                {/* start of portal content */}
                <div className="portal">

                  {/* start of portal body */}
                  <div className='portal-body latest-blog'>
                    <div className='table-content'>
                      <div className="row g-4">
                        {blogs && blogs.length > 0 ? (
                          blogs.map((blog) => (
                            <div className="col-md-6 col-lg-4 col-xl-4" key={blog.id}>
                              <div className="card shadow-sm border-0 rounded-4 overflow-hidden position-relative">
                                {/* Top colored image placeholder with date badge */}
                                <div className="align-items-start justify-content-start position-relative">
                                  <span className="badge bg-dark position-absolute top-0 start-0 m-2">
                                    {(() => {
                                      const date = new Date(blog.createdDateTime);
                                      const day = String(date.getDate()).padStart(2, '0');
                                      const month = date.toLocaleString('default', { month: 'short' }).toUpperCase();
                                      return `${day} ${month}`;
                                    })()}
                                  </span>
                                  <div className="justify-content-center align-items-center text-white fs-4 fw-bold">
                                    <Link to={`/blog/view/${blog.id}`}>
                                      <img
                                        src={`${config.imageBasePath}/blog/${blog.id}.${blog.image}`}
                                        alt={blog.name}
                                        className='img-fluid image-xs grid-blog-img'
                                      />
                                    </Link>
                                  </div>
                                </div>

                                {/* Blog content */}
                                <div className="card-body">
                                   <p className="text-secondary small mb-1 mt-1"><i className="bi bi-list me-1" ></i>{blog.blogCategory.name}</p>
                                  <h5 className="card-title fw-bold">
                                    <Link to={`/blog/view/${blog.id}`} className="text-decoration-none text-dark">
                                      {blog.name?.substring(0, 30)}
                                    </Link>
                                  </h5>

                                  <p className="card-text text-muted">{blog.description?.substring(0, 50) + '...'}</p>
                                  <hr></hr>
                                  <p className="text-secondary small mb-0">
                                    <i className="bi bi-calendar-event"></i>{" "}
                                    {(() => {
                                      const date = new Date(blog.createdDateTime);
                                      const day = String(date.getDate()).padStart(2, '0');
                                      const month = String(date.getMonth() + 1).padStart(2, '0');
                                      const year = date.getFullYear();
                                      return `${day}-${month}-${year}`;
                                    })()}
                                    <i className="bi bi-clock ms-2 me-1"></i>
                                    {(() => {
                                      const date = new Date(blog.createdDateTime);
                                      let hours = date.getHours();
                                      const minutes = String(date.getMinutes()).padStart(2, '0');
                                      const ampm = hours >= 12 ? 'PM' : 'AM';
                                      hours = hours % 12;
                                      hours = hours ? hours : 12;
                                      return `${hours}:${minutes} ${ampm}`;
                                    })()}
                                  </p>
                                </div>
                              </div>
                            </div>

                          ))
                        ) : (
                          <div className="col-12 text-center">
                            <p>No blogs found</p>
                          </div>
                        )}
                      </div>

                    </div>
                  </div>

                  {/* Pagination Controls */}
                  <div className="pagination-buttons">
                    {page > 1 && (
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                      >
                        Prev
                      </button>
                    )}

                    <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                    {page < totalPages && (
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                      >
                        Next
                      </button>
                    )}
                  </div>

                  <br></br>
                  {/* end of portal title */}

                </div>
                {/* end of portal content */}
              </div>

            </div>
          </div>
          {/* end of page content */}

        </div>
        {/* end of page */}

      </div>
    </>
  );
}